import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Observable } from "rxjs";

import { environment } from "../../../environments/environment";
import { GlobalErrorHandlerService } from "./global-error-handler/global-error-handler.service";
import { inject } from "@angular/core";
import { CountModel } from "../../features/shared/models/count.model";

export interface HttpResponseModel<T> {
    status: string;
    data?: T;
    count?: CountModel;
    message?: string;
}

export abstract class BaseHttpService {

    protected baseUrl = environment.apiUrl;

    constructor(
        protected httpClient: HttpClient,
    ) { }

    protected handleError(error: HttpErrorResponse, showSnackBar: boolean = true): Observable<never> {
        const errorHandler = inject(GlobalErrorHandlerService);
        return errorHandler.handleError(error, showSnackBar);
    }
}